import ReactSelect from "react-select";
import CreatableSelect from "react-select/creatable";
import classNames from "classnames";
import InputWrapper from "./InputWrapper";

const formatCreateLabel = (value) => <span>Add "{value}"</span>;

const Select = ({
                    name,
                    required = false,
                    label,
                    formik,
                    handleBlur,
                    handleChange,
                    options,
                    value,
                    placeholder = "Select option...",
                    isMulti = false,
                    isCreatable = false,
                    error,
                    description,
                    inputWrapperClassName,
                    layout
                }) => {

    const toOption = (optionValue) => (
        options?.find(option => option.value === optionValue)
        ?? (isCreatable && optionValue ? {value: optionValue, label: optionValue} : null)
    );

    const getFormikValue = () => {
        const fieldValue = formik.values[name];

        return isMulti
            ? (fieldValue ?? []).map(toOption).filter(Boolean)
            : toOption(fieldValue);
    }

    const onChange = (selected, actionMeta) => {
        if (typeof handleChange === 'function') {
            handleChange(selected, actionMeta);
            return
        }

        formik?.setFieldValue(name, isMulti ? selected.map(option => option.value) : selected?.value ?? null);
    }

    const onBlur = (e) => {
        if (typeof handleBlur === 'function') {
            handleBlur(e);
            return
        }

        formik?.handleBlur(e);
    }

    const fieldError = error || (formik?.touched[name] && formik?.errors[name]);
    const SelectComponent = isCreatable ? CreatableSelect : ReactSelect;

    return (
        <InputWrapper
            formik={formik}
            error={error}
            description={description}
            inputWrapperClassName={classNames("select-input", inputWrapperClassName)}
            layout={layout}
            label={label}
            name={name}
            required={required}
        >
            <SelectComponent
                inputId={name}
                isMulti={isMulti}
                options={options}
                value={formik ? getFormikValue() : value}
                onChange={onChange}
                onBlur={onBlur}
                placeholder={placeholder}
                className={classNames("react-select-container", {"has-error": fieldError})}
                classNamePrefix="react-select"
                menuPosition="fixed"
                formatCreateLabel={formatCreateLabel}
            />
        </InputWrapper>
    )
}

export default Select;
